/*
 * @Author: lijing
 * @Date: 2022-08-25 10:40:08
 * @Last Modified by: lijing
 * @Last Modified time: 2022-10-17 17:48:30
 */
import React, { useState, useEffect, FC } from "react";
import {
  Form,
  Select,
  Space,
  Button,
  Input,
  Table,
  Modal,
  message,
} from "antd";
import { useSelector } from "react-redux";
import {
  getCourseAuditList,
  getCourseAuditInfo,
  auditUpdate,
  auditPass,
} from "../../common/service";
import type { ColumnsType } from "antd/es/table";
import { RootState } from "@root/store/index";
import { CoursePreview } from "@root/components/coursePreview/index";
import { queryInstituteList } from "@root/common/utils";

interface DataType {
  updateTime: string;
  createBy: string;
  createTime: string;
  id: number;
  type: number;
  name: string;
  image: string;
  originalImage: string;
  introduction: string;
  waterMark: number;
  content: string;
  status: number;
  auditStatus: number;
  showOrder: number;
  instituteId: number;
  userType: string;
  ownerType: number;
  shareWithCounty: number;
  clickCount: number;
  tagInfo: string;
  subjectInfo: string;
  centerCategoryInfo: string;
  imageAllPath: string;
  originalImageAllPath: string;
  createTimeText: string;
  updateTimeText: string;
  statusText: string;
  auditStatusText: string;
  instituteName: string;
  returnReason: string;
}

interface IAuditInfoProp {
  totalCount: number;
  unAuditCount: number;
  passCount: number;
  unPassCount: number;
}

const { Option } = Select;
const { TextArea } = Input;
const CourseReview: FC = () => {
  const { instituteList = [] } = useSelector(
    (state: RootState) => state.directionaries
  );
  const columns: ColumnsType<DataType> = [
    {
      title: "",
      dataIndex: "imageAllPath",
      key: "imageAllPath",
      render(text, data) {
        return (
          <img
            height="70"
            src={text}
            onClick={() => {
              onPreviewClickHandle(data.id);
            }}
          />
        );
      },
    },
    {
      title: "课程名称",
      dataIndex: "name",
      key: "name",
      render(text, data) {
        return (
          <div
            onClick={() => {
              onPreviewClickHandle(data.id);
            }}
          >
            <div>{text}</div>
            <div>id：{data.id} &nbsp;预览</div>
          </div>
        );
      },
    },
    {
      title: "标签",
      dataIndex: "tagInfo",
      key: "tagInfo",
    },
    {
      title: "学科分类",
      dataIndex: "subjectInfo",
      key: "subjectInfo",
    },
    {
      title: "状态",
      dataIndex: "auditStatusText",
      key: "auditStatusText",
    },
    {
      title: "审核意见",
      dataIndex: "returnReason",
      key: "returnReason",
    },
    {
      title: "操作",
      key: "address",
      render: (_, record) => (
        <>
          {_.auditStatus === 1 && (
            <Button
              type="link"
              onClick={() => {
                onCancelPassClickHandle(record.id);
              }}
            >
              取消通过
            </Button>
          )}
          {_.auditStatus === 0 && (
            <Space>
              <Button
                type="link"
                onClick={() => {
                  onPassClickHandle(record.id);
                }}
              >
                审核通过
              </Button>
              <Button
                type="link"
                onClick={() => {
                  onRejectClickHandle(record.id);
                }}
              >
                审核驳回
              </Button>
            </Space>
          )}
        </>
      ),
    },
  ];

  const [form] = Form.useForm();
  const [reason] = Form.useForm();
  const [curoseList, setCuroseList] = useState<DataType[]>([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableTotal, setTableTotal] = useState(1);
  const [tablePageNum, setTablePageNum] = useState(1);
  const [selectCourse, setSelectCourse] = useState<React.Key[]>([]);
  const [auditInfo, setAuditInfo] = useState<IAuditInfoProp | null>(null);
  const [searchCondit, setSearchCondit] = useState<any>({});
  const [reasonVis, setReasonVis] = useState(false);
  const [reasonIds, setReasonIds] = useState<number[]>([]);
  const [isCoursePreviewVisible, setIsCoursePreviewVisible] = useState(false);
  const [previewId, setPreviewId] = useState(0);

  const getAduitList = async (page = tablePageNum) => {
    getCourseAudit();
    setTableLoading(true);
    setTablePageNum(page);
    getCourseAuditList({ pageNum: page, pageSize: 10 }, { ...searchCondit })
      .then((res) => {
        const {
          data: { rows, total },
        } = res;
        setCuroseList(rows);
        setTableTotal(total);
      })
      .finally(() => {
        setTableLoading(false);
      });
  };

  const getCourseAudit = () => {
    getCourseAuditInfo().then((res) => {
      setAuditInfo(res.data);
    });
  };

  const onSearchClickHandle = () => {
    const params = form.getFieldsValue();
    if (params.auditStatus === -1) {
      delete params.auditStatus;
    }
    setSearchCondit(params);
  };

  const onResetClickHandle = () => {
    form.resetFields();
    setSearchCondit({});
  };

  const onCancelPassClickHandle = (id: number) => {
    Modal.confirm({
      title: "提示",
      content: "确认取消通过课程？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        return new Promise((resolve, reject) => {
          auditPass({ courseId: id }).then((res) => {
            message.success("操作成功");
            getAduitList();
            setSelectCourse([]);
            resolve("操作成功");
          });
        });
      },
    });
  };

  const onPassClickHandle = (id: number) => {
    Modal.confirm({
      title: "提示",
      content: "确认审核通过此课程？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        return new Promise((resolve, reject) => {
          auditUpdate({ courseIdList: [id], auditStatus: 1 }).then((res) => {
            message.success("操作成功");
            getAduitList();
            resolve("操作成功");
          });
        });
      },
    });
  };

  const onRejectClickHandle = (id: number) => {
    setReasonIds([id]);
    setReasonVis(true);
  };

  const onReasonSubmitClickHandle = () => {
    reason.validateFields().then((res) => {
      auditUpdate({
        courseIdList: reasonIds,
        auditStatus: 2,
        returnReason: res.returnReason,
      }).then((res) => {
        message.success("操作成功");
        getAduitList();
        setReasonVis(false);
      });
    });
  };

  const onBatchPassClickHandle = () => {
    Modal.confirm({
      title: "提示",
      content: "确认审核通过课程？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        return new Promise((resolve, reject) => {
          auditUpdate({ courseIdList: selectCourse, auditStatus: 1 }).then(
            (res) => {
              message.success("操作成功");
              getAduitList();
              setSelectCourse([]);
              resolve("操作成功");
            }
          );
        });
      },
    });
  };

  const onPreviewClickHandle = (id: number) => {
    setPreviewId(id);
    setIsCoursePreviewVisible(true);
  };

  useEffect(() => {
    getAduitList();
  }, [searchCondit]);

  useEffect(() => {
    if (reasonVis === false) {
      reason.resetFields();
    }
  }, [reasonVis]);

  return (
    <div className="coursereview">
      <Form name="customized-form-controls" layout="inline" form={form}>
        <Form.Item name="courseId" label="ID">
          <Input style={{ width: 180 }} />
        </Form.Item>
        <Form.Item name="name" label="课程名称">
          <Input style={{ width: 180 }} />
        </Form.Item>
        <Form.Item name="auditStatus" label="状态">
          <Select style={{ width: 180 }}>
            <Option value={-1}>全部</Option>
            <Option value={0}>待审核</Option>
            <Option value={1}>审核通过</Option>
          </Select>
        </Form.Item>
        <Form.Item label="工作单位" name="instituteId">
          <Select
            style={{ width: 180 }}
            showSearch
            filterOption={(input, option) =>
              (option!.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            onSearch={(val) => {
              queryInstituteList(val);
            }}
          >
            {instituteList.map((item, index) => {
              return (
                <Option value={item.id} key={index}>
                  {item.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </Form>
      <div className="coursereview-form-btns">
        <Space>
          <Button
            type="primary"
            onClick={() => {
              onSearchClickHandle();
            }}
          >
            查询
          </Button>
          <Button
            type="primary"
            onClick={() => {
              onResetClickHandle();
            }}
          >
            重置
          </Button>
        </Space>
      </div>
      <div className="coursereview-option">
        <div className="coursereview-option-total">
          {auditInfo &&
            `总数量(${auditInfo.totalCount}条) 待审核(${auditInfo.unAuditCount}条) 已通过(${auditInfo.passCount}条)`}
        </div>
        <div className="coursereview-option-btns">
          <Space>
            <Button
              type="primary"
              onClick={() => {
                onBatchPassClickHandle();
              }}
            >
              批量通过
            </Button>
          </Space>
        </div>
      </div>
      <div className="coursereview-table">
        <Table
          rowKey="id"
          loading={tableLoading}
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: selectCourse,
            onChange: (array) => {
              setSelectCourse(array as number[]);
            },
          }}
          columns={columns}
          dataSource={curoseList}
          pagination={{
            pageSize: 10,
            total: tableTotal,
            onChange: (page) => {
              getAduitList(page);
            },
            showTotal: (total) => {
              return "共" + total + "条记录";
            },
          }}
        />
      </div>
      <Modal
        title="提示"
        visible={reasonVis}
        onOk={() => {
          onReasonSubmitClickHandle();
        }}
        onCancel={() => {
          setReasonVis(false);
        }}
      >
        <p>确认审核驳回此课程？ </p>
        <Form form={reason} layout="vertical">
          <Form.Item
            name="returnReason"
            label="请填写审核意见"
            rules={[{ required: true, message: "请输入审核意见" }]}
          >
            <TextArea
              style={{ height: 120, resize: "none" }}
              maxLength={300}
              showCount
            />
          </Form.Item>
        </Form>
      </Modal>
      {isCoursePreviewVisible && (
        <CoursePreview
          previewId={previewId}
          setIsCoursePreviewVisible={setIsCoursePreviewVisible}
        />
      )}
    </div>
  );
};

export default CourseReview;
